const alarmTypeMap = {
  'FT_R': {
    name: '誤觸異常',
    hasRain: false,
    hasSimultaneous: false,
    isContinuous: false,
    isRecovered: true,
    isTemp: false,
    isSpike: false,
  },
  'FT_N': {
    name: '誤觸異常',
    hasRain: false,
    hasSimultaneous: false,
    isContinuous: false,
    isRecovered: false,
    isTemp: false,
    isSpike: false,
  },
  'FT_P': {
    name: '突波',
    hasRain: false,
    hasSimultaneous: false,
    isContinuous: false,
    isRecovered: null,
    isTemp: false,
    isSpike: true,
  },
  'C': {
    name: '潛移徵兆',
    hasRain: false,
    hasSimultaneous: false,
    isContinuous: false,
    isRecovered: null,
    isTemp: false,
  },
  'C_R': {
    name: '潛移徵兆',
    hasRain: true,
    hasSimultaneous: false,
    isContinuous: false,
    isRecovered: null,
    isTemp: false,
  },
  'C_S': {
    name: '潛移徵兆',
    hasRain: false,
    hasSimultaneous: true,
    isContinuous: false,
    isRecovered: null,
    isTemp: false,
  },
  'C_RS': {
    name: '潛移徵兆',
    hasRain: true,
    hasSimultaneous: true,
    isContinuous: false,
    isRecovered: null,
    isTemp: false,
  },
  'CC': {
    name: '連續潛移',
    hasRain: false,
    hasSimultaneous: false,
    isContinuous: true,
    isRecovered: null,
    isTemp: false,
  },
  'CC_R': {
    name: '連續潛移',
    hasRain: true,
    hasSimultaneous: false,
    isContinuous: true,
    isRecovered: null,
    isTemp: false,
  },
  'CC_S': {
    name: '連續潛移',
    hasRain: false,
    hasSimultaneous: true,
    isContinuous: true,
    isRecovered: null,
    isTemp: false,
  },
  'CC_RS': {
    name: '連續潛移',
    hasRain: true,
    hasSimultaneous: true,
    isContinuous: true,
    isRecovered: null,
    isTemp: false,
  },
  'TM': {
    name: '溫度效應',
    hasRain: false,
    hasSimultaneous: false,
    isContinuous: false,
    isRecovered: null,
    isTemp: true,
  },
};

export default alarmTypeMap;